import { useIntl } from 'react-intl';

import Button from 'client/components/aria/Button/Button';

import { useDispatch } from 'react-redux';

import { removeMapMode } from 'client/store/mapSlice/mapSlice';
import { mapModes } from 'client/utils/constants/appStates';

const CancelObservationButton = () => {
    const intl = useIntl();
    const dispatch = useDispatch();

    const handleOnPress = () => {
        dispatch(removeMapMode(mapModes.ADDING_OBSERVATION));
    };

    return <Button data-testid="mapToolBar.observation.cancel"
        variant="error"
        onPress={handleOnPress}>
        { intl.formatMessage({ id: 'general.cancel' }) }
    </Button>;
};

export default CancelObservationButton;
